import { deduplicate } from './arrays';

export const sharedContentEntryIDsReferencedInBoard = (sharedContentBoard) => {
  if (!sharedContentBoard) {
    return [];
  }
  return deduplicate(
    (sharedContentBoard?.lanes || []).reduce(
      (acc, lane) => [...acc, ...(lane.entries || []).map((e) => e.objectID)],
      [],
    ),
  );
};

export const parentOfSharedContentEntryID = (
  sharedContentEntryID,
  sharedContentBoards,
) =>
  (sharedContentBoards || []).find((b) =>
    sharedContentEntryIDsReferencedInBoard(b).includes(sharedContentEntryID),
  );

export const parentIDOfSharedContentEntryID = (
  sharedContentEntryID,
  sharedContentBoards,
) =>
  parentOfSharedContentEntryID(sharedContentEntryID, sharedContentBoards)?.id;
